export interface ColumnArticle {
  id: string;
  title: string;
  subtitle: string;
  abstract: string;
  category: string;
  publishedAt: string;
  readTime: number;
  tags: string[];
  viewCount: number;
  likeCount: number;
  commentCount: number;
  featured?: boolean;
  collectionTag?: string;
}

export const columnCategories = ['全部', '政策深析', '合规实务', '实操指南', '风险警示', '案例解析', '行业动态', '市场研判'];

export interface ColumnCollection {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  themeColor: string;
  accentColor: string;
  bgGradient: string;
  coverImage: string;
  articleIds: string[];
  icon: string;
}

export const columnCollections: ColumnCollection[] = [
  {
    id: 'legal-compliance',
    title: '法律·合规·风险',
    subtitle: '法务视角深度合规解析系列',
    description: '以法律从业者视角，系统拆解RWA监管红线、跨境合规路径、项目全流程风控、无形资产合规难点及法律意见书核心要点，是从业者和项目方不可或缺的合规进阶指南。',
    themeColor: '#1E3A5F',
    accentColor: '#C9A84C',
    bgGradient: 'from-[#0F2340] to-[#1E3A5F]',
    coverImage: 'https://public.readdy.ai/ai/img_res/3456bf32ff456d2b0a723866ba1576b5.jpg',
    articleIds: ['col-018', 'col-019', 'col-020', 'col-021', 'col-022', 'col-023', 'col-024'],
    icon: 'ri-scales-3-line',
  },
  {
    id: 'market-research',
    title: '市场研判',
    subtitle: '独立视角RWA市场深度研究系列',
    description: '以独立研究者视角，深度剖析全球RWA市场规模演进、资产多元化浪潮、机构资本布局逻辑与行业趋势前瞻，为投资者和从业者提供穿越周期的方法论。',
    themeColor: '#064E3B',
    accentColor: '#10B981',
    bgGradient: 'from-[#022C22] to-[#064E3B]',
    coverImage: 'https://readdy.ai/api/search-image?query=market%20research%20RWA%20analysis%20financial%20data%20visualization%20charts%20trading%20floor%20dark%20green%20emerald%20digital%20finance%20professional%20futuristic&width=800&height=450&seq=col_coll02&orientation=landscape',
    articleIds: ['col-017', 'col-016', 'col-013', 'col-012', 'col-010'],
    icon: 'ri-line-chart-line',
  },
  {
    id: 'policy-analysis',
    title: '政策深析',
    subtitle: '全球RWA监管框架与政策解读系列',
    description: '系统梳理中国八部委新政、香港SFC监管框架、全球MiCA/CLARITY Act等核心政策，深度解析监管智慧与合规红利，为政策研究者和企业决策层提供战略参考。',
    themeColor: '#3B0764',
    accentColor: '#A78BFA',
    bgGradient: 'from-[#1A0050] to-[#2E1065]',
    coverImage: 'https://readdy.ai/api/search-image?query=policy%20analysis%20RWA%20government%20regulation%20global%20financial%20compliance%20framework%20law%20parliament%20dark%20purple%20gold%20official%20document%20professional&width=800&height=450&seq=col_coll03&orientation=landscape',
    articleIds: ['col-015', 'col-007', 'col-001', 'col-006'],
    icon: 'ri-government-line',
  },
  {
    id: 'practical-guide',
    title: '实战操盘',
    subtitle: 'RWA项目落地实操与案例解析系列',
    description: '覆盖内地企业赴港发行全流程、境内确权存证实操、中小企业低成本合规路径、绿色能源RWA标杆案例等核心议题，每篇均附可复制的实操方法论和典型项目深度解析。',
    themeColor: '#134E4A',
    accentColor: '#2DD4BF',
    bgGradient: 'from-[#042F2E] to-[#134E4A]',
    coverImage: 'https://readdy.ai/api/search-image?query=practical%20guide%20RWA%20project%20implementation%20operation%20checklist%20workflow%20blockchain%20real%20asset%20tokenization%20dark%20teal%20cyan%20professional%20systematic&width=800&height=450&seq=col_coll04&orientation=landscape',
    articleIds: ['col-014', 'col-011', 'col-008', 'col-005', 'col-002'],
    icon: 'ri-tools-line',
  },
  {
    id: 'risk-warning',
    title: '风险警示',
    subtitle: '非法RWA识别与投资者防骗指南系列',
    description: '系统揭示非法RWA骗局的七十二变、香港合规市场的隐蔽陷阱与企业合规风控体系构建方法，提供可操作的识别工具和维权路径，守护投资者资产安全。',
    themeColor: '#7F1D1D',
    accentColor: '#F87171',
    bgGradient: 'from-[#450A0A] to-[#7F1D1D]',
    coverImage: 'https://readdy.ai/api/search-image?query=risk%20warning%20fraud%20detection%20RWA%20blockchain%20scam%20identification%20warning%20shield%20protection%20dark%20red%20professional%20security%20alert%20investor%20protection&width=800&height=450&seq=col_coll05&orientation=landscape',
    articleIds: ['col-009', 'col-003', 'col-004'],
    icon: 'ri-shield-flash-line',
  },
];

export const columnArticles: ColumnArticle[] = [
  {
    id: 'col-017',
    title: 'RWA 2.0宣言：从规模扩张到价值深耕的行业蜕变',
    subtitle: '当浮躁褪去，留下的才是真正的金子——2026年，RWA行业的自我革命',
    abstract: '2026年，RWA正式迈入2.0时代。这不是空喊的行业口号，而是我结合多年研究、市场数据、项目落地得出的务实结论。RWA 2.0的核心，是从早期的规模扩张，转向深度的价值深耕——彻底告别概念炒作，聚焦实体赋能与长期价值。全球链上RWA总价值突破350亿美元，机构持仓占比持续提升，技术从单纯代币发行走向隐私合规与流动性优化，监管从灰色地带走向合规共识。本文深度剖析RWA 1.0与2.0的本质区别，预判2.0时代三大核心变化，为行业从业者提供穿越周期的方法论。',
    category: '行业动态',
    publishedAt: '2026-03-31T16:00:00',
    readTime: 20,
    tags: ['RWA 2.0', '行业蜕变', '价值深耕', '市场研判', '行业洗牌'],
    viewCount: 18920,
    likeCount: 1563,
    commentCount: 198,
    featured: true,
    collectionTag: 'market-research',
  },
  {
    id: 'col-016',
    title: '债券之后：多元资产布局才是RWA增长的真正引擎',
    subtitle: '从单一赛道到全品类覆盖，这是资本用脚投票的答案',
    abstract: '早期RWA等同于"债券上链"的时代已经终结。从私募信贷、商业地产到贵金属战略物料，再到碳资产与知识产权，资产品类的全面突破才是RWA市场持续扩容的关键动力。本文基于全球RWA最新数据，深度拆解各类资产赛道的增长逻辑、典型项目案例，以及多元资产布局下RWA从"单一产品"走向"全品类资管"的完整升级路径，给出独立的市场判断与投资视角。',
    category: '市场研判',
    publishedAt: '2026-03-31T10:30:00',
    readTime: 22,
    tags: ['多元资产', '私募信贷', '商业地产', '贵金属', '碳资产', '赛道研判'],
    viewCount: 14380,
    likeCount: 1102,
    commentCount: 143,
    featured: true,
    collectionTag: 'market-research',
  },
  {
    id: 'col-015',
    title: '监管大棋局：全球RWA合规化浪潮的底层逻辑与中国机遇',
    subtitle: '监管不是枷锁，而是筛选器——合规者得天下，投机者终出局',
    abstract: '全球主要经济体对RWA的监管态度已从观望、警惕转向理性规范。美国《CLARITY Act》划定法律边界，欧盟MiCA框架全面落地，香港确立亚洲RWA中心定位，新加坡跨境交易破百亿美元。中国以香港为支点参与全球话语权争夺，双轨制监管框架构建"堵疏结合"的中国特色路径。本文系统梳理全球监管演进脉络，深度解析"合规为王"时代的竞争逻辑，为真正有价值的RWA项目指明发展方向。',
    category: '政策深析',
    publishedAt: '2026-03-30T15:30:00',
    readTime: 24,
    tags: ['全球监管', 'CLARITY Act', 'MiCA', '香港政策', '合规为王', '中国机遇'],
    viewCount: 16250,
    likeCount: 1289,
    commentCount: 167,
    featured: true,
    collectionTag: 'policy-analysis',
  },
  {
    id: 'col-014',
    title: '机构时代：专业资本入场与基建完善如何重塑RWA格局',
    subtitle: '不再是初创团队单打独斗——当华尔街与区块链握手，行业真正变了',
    abstract: '近两年全球RWA的最大变量，不是技术升级，不是政策转向，而是机构资本的深度介入。Midas 5000万美元A轮融资、Valinor 2500万美元种子轮、BlackRock BUIDL突破120亿美元——这些数字背后，是整个行业从"加密野路子"走向"机构正规军"的根本转变。本文深度解析机构入场的多个维度：融资端的大额布局、技术端的合规突破、合作端的传统金融接轨，以及这场变革对从业者、投资者与实体企业的深远影响。',
    category: '行业动态',
    publishedAt: '2026-03-30T09:00:00',
    readTime: 19,
    tags: ['机构入场', 'BlackRock', 'Midas', '基础设施', '行业格局', '规模化'],
    viewCount: 12640,
    likeCount: 967,
    commentCount: 121,
    collectionTag: 'practical-guide',
  },
  {
    id: 'col-024',
    title: '2026年RWA合规趋势前瞻：从"备案合规"到"生态合规"的进化',
    subtitle: '合规不是静止的靶标，而是随行业动态演进的生命体——读懂未来才能布局当下',
    abstract: '2026年是RWA行业的"合规元年"，但合规不是静态的，而是随着市场发展、技术迭代持续进化的。基于对全球监管动态、行业实践的深度观察，本文判断未来1-2年，RWA合规将呈现三大趋势：从"单点备案"到"生态合规"、从"形式合规"到"实质合规"、从"区域监管"到"全球协同"。这些趋势将深刻影响行业格局，也为项目方提供了新的合规机遇。此外，合规科技的崛起将重塑风控效率，AI与大数据将使监管从被动响应走向主动预防。',
    category: '行业动态',
    publishedAt: '2026-03-29T23:55:00',
    readTime: 23,
    tags: ['合规趋势', '生态合规', '全球协同', '合规科技', 'AI监管', '2026展望'],
    viewCount: 11840,
    likeCount: 963,
    commentCount: 119,
    featured: true,
    collectionTag: 'legal-compliance',
  },
  {
    id: 'col-013',
    title: '万亿沉睡资产的破局之道：RWA的本质从未是"上链"',
    subtitle: '资产代币化只是手段，盘活锁死的万亿价值才是终点',
    abstract: '见过太多人把RWA简单等同于"现实资产发个代币上链"，甚至觉得这只是加密圈的又一个噱头。看完市场这两年的真实走向，我可以很肯定地说：这种认知，完全没摸到RWA的本质。真正的RWA，从来不是为了上链而上链，而是针对传统金融里万亿级沉睡资产的破局方案，是把锁死的资产变活、把低效的流转变高效的务实变革。本文从沉睡资产的本质困境切入，以真实案例和市场数据，系统阐释RWA创造价值的底层逻辑，重建关于这个赛道的认知基础。',
    category: '市场研判',
    publishedAt: '2026-03-29T10:00:00',
    readTime: 21,
    tags: ['RWA本质', '沉睡资产', '流动性', '价值重构', '认知纠偏'],
    viewCount: 11280,
    likeCount: 876,
    commentCount: 108,
    collectionTag: 'market-research',
  },
  {
    id: 'col-012',
    title: '前瞻2026：RWA行业的四条主线与变革底色',
    subtitle: '这一年，不只是政策元年，更是行业认知重建的起点',
    abstract: '2026年是中国RWA行业无可争议的政策元年。但政策落地只是起点，真正的行业重塑还在后面。绿色能源赛道的主导化、合规能力的竞争化、中小企业参与度的提升、跨境协同的深化——四条主线将共同构成2026年下半年乃至2027年RWA行业演进的底层逻辑。本文是对未来12个月行业趋势的深度研判，结合政策、市场、资本三个维度，给出作者的独立判断与前瞻性思考。',
    category: '行业动态',
    publishedAt: '2026-03-28T09:00:00',
    readTime: 17,
    tags: ['行业趋势', '前瞻研判', '2026', 'RWA元年'],
    viewCount: 15640,
    likeCount: 1234,
    commentCount: 162,
    featured: true,
    collectionTag: 'market-research',
  },
  {
    id: 'col-011',
    title: '中小企突围：RWA合规布局的低成本路径与方法论',
    subtitle: '资源有限，但不是不合规的理由，更不是错过赛道的借口',
    abstract: '大量中小企业误认为RWA是"大企业的专利"，或因成本顾虑望而却步。然而，某知识产权科技企业的案例证明：通过"聚焦核心资产+借力外部服务+申请政策补贴"三步组合，发行成本可控制在规模的3%以内。本文系统梳理中小企业低成本合规布局RWA的完整方法论，拆解成本结构、难点解法与政策红利，为有意探索的中小企业提供真正可行的突围路径。',
    category: '实操指南',
    publishedAt: '2026-03-25T10:30:00',
    readTime: 20,
    tags: ['中小企业', 'RWA布局', '低成本合规', '实战方法'],
    viewCount: 10760,
    likeCount: 834,
    commentCount: 91,
    collectionTag: 'practical-guide',
  },
  {
    id: 'col-023',
    title: 'RWA项目法律意见书核心要点解析：合规的"最后一道防线"',
    subtitle: '法律意见书不是走流程，是监管备案的核心武器——每一条结论都要有事实依据',
    abstract: '在RWA项目中，法律意见书不是"形式文件"，而是监管备案的核心依据，也是投资者判断项目合规性的重要参考。2026年新政实施后，证监会明确要求境内RWA出海项目必须提供境内法律意见书，确认项目不存在六大禁止情形。很多项目方随便找家律所出具，结果因意见书中存在"模糊表述""核查不到位"，导致备案被拒。本文深度拆解法律意见书的四大核心要点，揭示律所核查的正确方式与常见盲区，为项目方提供实操指导。',
    category: '合规实务',
    publishedAt: '2026-03-22T00:33:00',
    readTime: 21,
    tags: ['法律意见书', '合规备案', '律所核查', '穿透合规', '监管要件', '法律实务'],
    viewCount: 9320,
    likeCount: 746,
    commentCount: 92,
    collectionTag: 'legal-compliance',
  },
  {
    id: 'col-010',
    title: '数据密码：香港RWA一季度市场全景解读',
    subtitle: '85亿港元背后，是一个市场从混沌走向秩序的完整叙事',
    abstract: '2026年一季度，香港RWA发行规模达85亿港元，同比增长120%，合规项目数量、持牌机构数量、投资者结构均出现显著改善。这些数据背后，隐藏着香港RWA市场从政策驱动向市场驱动转型的关键信号。本文对一季度官方数据进行深度解读，逐一拆解数据背后的结构性变化与市场趋势，并对2026年全年市场走势给出独立判断。',
    category: '行业动态',
    publishedAt: '2026-03-20T09:00:00',
    readTime: 15,
    tags: ['香港市场', '行业数据', '市场分析', '趋势研判'],
    viewCount: 8920,
    likeCount: 693,
    commentCount: 72,
    collectionTag: 'market-research',
  },
  {
    id: 'col-009',
    title: '法网之外：香港非法RWA骗局揭秘与投资者自保指南',
    subtitle: '在最规范的市场里，依然潜伏着最隐蔽的陷阱',
    abstract: '香港金融市场的高度规范化，反而被部分不法分子利用为"信任背书"——伪造SFC牌照、伪造持牌机构合作协议、伪造尽职调查报告，制造"伪合规"幻象诱骗投资者。近期香港警方联合SFC查处的1.2亿港元非法集资骗局，正是这一模式的典型案例。本文深度拆解香港非法RWA的五大新型骗局，并给出一套经过验证的三步识别法与完整维权路径。',
    category: '风险警示',
    publishedAt: '2026-03-16T14:30:00',
    readTime: 17,
    tags: ['香港风险', '非法集资', '骗局识别', '维权指南'],
    viewCount: 16230,
    likeCount: 1287,
    commentCount: 178,
    collectionTag: 'risk-warning',
  },
  {
    id: 'col-022',
    title: 'RWA项目核心风险图谱：从资产造假到跨境违规的全维度防控',
    subtitle: '风险不会消失，只会变得更隐蔽——2026年RWA行业的四大致命风险与系统防控',
    abstract: 'RWA行业越发展，风险就越隐蔽。2026年以来，随着监管框架的完善，明目张胆的诈骗项目越来越少，但"合规包装下的隐形风险"却层出不穷：资产抵押率虚高、数据造假、跨境资金流动违规、智能合约漏洞——这些风险往往藏在复杂的交易架构和技术包装背后，一旦爆发，不仅导致项目崩盘，还引发监管追责。本文梳理RWA项目的四大核心风险类型及对应防控策略，全部来自实战积累的"保命经验"。',
    category: '风险警示',
    publishedAt: '2026-03-14T22:08:00',
    readTime: 22,
    tags: ['风险防控', '资产造假', '跨境违规', '智能合约风险', '流动性风险', '全维度风控'],
    viewCount: 10540,
    likeCount: 852,
    commentCount: 106,
    collectionTag: 'legal-compliance',
  },
  {
    id: 'col-008',
    title: '跨越山海：内地企业赴港发行RWA的完全手册',
    subtitle: '从一张纸到一枚代币，跨境合规的每一步都有章可循',
    abstract: '越来越多的内地企业将目光投向香港，希望借助香港持牌机构完成RWA的跨境发行。然而，赴港发行并非只是"换个地方发"那么简单——从前期合规评估、持牌机构筛选，到SFC申请、代币化设计，再到后续合规维护，每一步都潜藏着合规陷阱。本文是一份完整的赴港发行操作手册，覆盖全流程五大步骤与材料清单，为有意布局的企业提供系统指引。',
    category: '实操指南',
    publishedAt: '2026-03-12T10:00:00',
    readTime: 26,
    tags: ['赴港发行', '跨境合规', 'HashKey', 'OSL', '实操手册'],
    viewCount: 13540,
    likeCount: 1043,
    commentCount: 134,
    collectionTag: 'practical-guide',
  },
  {
    id: 'col-007',
    title: '香港棋局：国际金融中心的RWA监管智慧与战略布局',
    subtitle: '香港不是目的地，而是内地资产走向世界的战略跳板',
    abstract: '2026年，香港在RWA领域的战略布局日趋清晰：完善监管框架、打造产业集群、加强国际合作，三管齐下，将自身定位为内地企业境外发行RWA的核心枢纽。本文深入解析香港RWA监管框架的核心逻辑，梳理其与内地新政的协同衔接机制，并对香港在全球RWA版图中的战略定位给出独到判断——香港的价值，远不止于一个发行地。',
    category: '政策深析',
    publishedAt: '2026-03-08T09:30:00',
    readTime: 21,
    tags: ['香港监管', 'SFC', '跨境合规', '国际布局'],
    viewCount: 9870,
    likeCount: 789,
    commentCount: 88,
    featured: true,
    collectionTag: 'policy-analysis',
  },
  {
    id: 'col-021',
    title: '无形资产RWA合规难点拆解：知识产权与数据资产的代币化路径',
    subtitle: '无形资产的代币化，是RWA 2.0最复杂也最有价值的边疆——法律先行，技术随后',
    abstract: 'RWA行业发展到2026年，早已从不动产、大宗商品等有形资产，延伸到知识产权、数据资产等无形资产领域。但无形资产代币化的合规难度，远比有形资产复杂：权属界定模糊、现金流难以预测、数据合规风险高，稍有不慎就会触碰监管红线。本文深度拆解知识产权RWA与数据资产RWA的合规核心，剖析权利界定与风险隔离的实操路径，揭示"三权分置"数据资产框架下的合规窗口，为无形资产代币化从业者提供法律先行的系统指导。',
    category: '合规实务',
    publishedAt: '2026-03-06T01:47:00',
    readTime: 24,
    tags: ['无形资产', '知识产权RWA', '数据资产', '三权分置', '数据合规', '收益权代币化'],
    viewCount: 8760,
    likeCount: 698,
    commentCount: 84,
    collectionTag: 'legal-compliance',
  },
  {
    id: 'col-006',
    title: '代价之镜：非法RWA发行的处罚始末与行业反思',
    subtitle: '一个企业的违规覆灭，是整个行业的警示教材',
    abstract: '某不动产企业在未完成境内确权存证、未取得境外发行资质的情况下，擅自在境内发行RWA，筹资5000万元，最终被监管部门查处，面临3000万元罚款、品牌崩塌、高管被追责的惨烈结局。本文深度复盘这一案例的完整始末，逐一拆解四类核心违规行为及其监管处罚依据，剖析企业违规的深层动机与认知盲区，为行业提供可汲取的教训。',
    category: '案例解析',
    publishedAt: '2026-03-05T15:00:00',
    readTime: 19,
    tags: ['违规处罚', '监管案例', '合规警示', '风险教育'],
    viewCount: 14380,
    likeCount: 1102,
    commentCount: 147,
    collectionTag: 'policy-analysis',
  },
  {
    id: 'col-005',
    title: '绿能觉醒：协鑫能科光伏RWA发行案例全解析',
    subtitle: '一个标杆案例，揭示绿色能源RWA合规发行的完整范式',
    abstract: '在八部委新政落地后，协鑫能科以光伏电站资产为底层标的，完成了国内首批真正意义上合规的绿色能源RWA发行。这个案例的价值，不仅在于发行规模，更在于它提供了一套可被复制的合规发行范式。本文对该案例进行六步全流程解析，重点拆解每一步的合规细节、操作难点与解决方案，为同类型企业提供具有实践价值的参考。',
    category: '案例解析',
    publishedAt: '2026-03-01T09:00:00',
    readTime: 24,
    tags: ['协鑫能科', '绿色能源', 'RWA案例', '合规发行'],
    viewCount: 11200,
    likeCount: 876,
    commentCount: 98,
    collectionTag: 'practical-guide',
  },
  {
    id: 'col-020',
    title: 'RWA项目全流程合规实操指南：从资产筛选到退出的风险控制',
    subtitle: '合规的80%在前期，技术只占20%——把风险想在前面，才是RWA项目的制胜之道',
    abstract: '很多项目方做RWA，只关注"代币怎么发"，却忽略了"合规怎么建"，结果往往是项目上线即整改。其实RWA项目的成功，80%取决于前期合规架构设计，20%才是技术实现。从资产筛选到最终退出，每一个环节都藏着合规风险点，只有把"风险隔离"做到位，才能避免"辛苦一场却因合规问题功亏一篑"。结合2026年新政要求和多个落地案例，本文梳理RWA项目全流程的核心合规要点。',
    category: '实操指南',
    publishedAt: '2026-02-27T14:30:00',
    readTime: 25,
    tags: ['全流程合规', '资产筛选', 'SPV架构', '技术合规', '退出机制', '实操指南'],
    viewCount: 10280,
    likeCount: 821,
    commentCount: 97,
    collectionTag: 'legal-compliance',
  },
  {
    id: 'col-004',
    title: '合规风控：RWA企业的生命线与护城河',
    subtitle: '没有风控体系，合规只是一句空话',
    abstract: '八部委新政要求企业建立完善的合规风控体系，但"要求"与"落地"之间，横亘着一条认知鸿沟。合规风控究竟是成本中心还是价值创造中心？风控体系的核心框架应如何搭建？中小企业如何在资源有限的情况下实现低成本合规风控？本文以"三层风控体系"为核心框架，结合企业实际场景，给出一套可落地的合规风控建设方案。',
    category: '合规实务',
    publishedAt: '2026-02-25T10:30:00',
    readTime: 20,
    tags: ['合规风控', '风控体系', '企业合规', '风险管理'],
    viewCount: 7640,
    likeCount: 598,
    commentCount: 67,
    collectionTag: 'risk-warning',
  },
  {
    id: 'col-003',
    title: '识骗防坑：非法RWA的七十二变与终极识别术',
    subtitle: '骗局在进化，识别能力也必须进化',
    abstract: '八部委新政的出台，并未终止非法RWA骗局的泛滥，反而催生了更为隐蔽的变种。从"空壳RWA"到"伪合规包装"，从传销式返现到"跨境套利"诱骗——骗局的七十二变令无数投资者与企业深陷其中。本文系统梳理六类高发非法RWA骗局的运作机制，并提供一套可操作的终极识别方法论，帮助读者建立稳固的认知防线。',
    category: '风险警示',
    publishedAt: '2026-02-21T14:00:00',
    readTime: 16,
    tags: ['风险警示', '非法RWA', '骗局识别', '投资者保护'],
    viewCount: 18760,
    likeCount: 1534,
    commentCount: 203,
    featured: true,
    collectionTag: 'risk-warning',
  },
  {
    id: 'col-019',
    title: '全球RWA监管差异对比：跨境项目的合规选择与风险规避',
    subtitle: '没有最优解，只有最适配解——不同司法辖区的规则差异决定了跨境项目的生死',
    abstract: '做跨境RWA项目，最容易踩的坑就是"用一套合规逻辑应对所有司法辖区"。不同国家对RWA的监管态度，本质是其金融体系、法律传统与风险偏好的体现：美国重证券属性穿透，欧盟重统一框架规范，香港、新加坡重创新与风险平衡，而中国则重实体资产锚定与跨境风险隔离。理解这些差异，才能为项目选择最合适的落地场景，避免"合规成本高于项目收益"的困境。本文系统对比四大司法辖区的监管逻辑，并给出跨境项目合规选择的实操框架。',
    category: '政策深析',
    publishedAt: '2026-02-18T23:12:00',
    readTime: 26,
    tags: ['全球监管对比', 'SEC监管', 'MiCA框架', '香港新加坡', '跨境合规', '监管套利'],
    viewCount: 9640,
    likeCount: 778,
    commentCount: 96,
    collectionTag: 'legal-compliance',
  },
  {
    id: 'col-002',
    title: '确权为纲：境内RWA资产代币化的实战法则',
    subtitle: '没有真实确权，一切代币化都是空中楼阁',
    abstract: '境内确权存证是RWA合规发行的命脉所在。然而现实中，大量企业对确权流程的理解停留在表面，材料准备不足、平台选择失当、流程倒置等问题频发。本文系统梳理境内RWA资产确权存证的全流程，针对不动产、绿色能源、知识产权三类核心资产的差异化路径详加阐释，并对企业最常陷入的七类操作误区予以逐一拆解。',
    category: '实操指南',
    publishedAt: '2026-02-15T09:30:00',
    readTime: 22,
    tags: ['确权存证', '资产代币化', '合规流程', '实操指南'],
    viewCount: 9320,
    likeCount: 712,
    commentCount: 89,
    collectionTag: 'practical-guide',
  },
  {
    id: 'col-018',
    title: 'RWA监管核心逻辑拆解：从"境内严禁"到"境外严管"的合规边界',
    subtitle: '监管从不是一刀切的否定，而是用"堵疏结合"逻辑划定真正合规的RWA赛道',
    abstract: '做RWA合规研究这些年，最直观的感受是：监管从来不是"一刀切"的否定，而是用"堵疏结合"的逻辑，为真正的实体资产代币化划定清晰赛道。2026年2月6日八部委42号文与证监会1号公告的出台，彻底终结了RWA行业"灰色游走"的阶段，让"境内严禁、境外严管"成为所有从业者必须坚守的底线。本文从监管逻辑的演进脉络出发，深度解析"境内严禁"的真正内涵与"境外严管"的合规突破口，揭示监管规律背后从业者真正需要掌握的核心认知。',
    category: '政策深析',
    publishedAt: '2026-02-10T22:35:00',
    readTime: 22,
    tags: ['监管逻辑', '境内严禁', '境外严管', '42号文', '合规边界', '备案路径'],
    viewCount: 11240,
    likeCount: 904,
    commentCount: 112,
    featured: true,
    collectionTag: 'legal-compliance',
  },
  {
    id: 'col-001',
    title: '新政破局：八部委《通知》的历史意义与行业重塑',
    subtitle: '一道政策分水岭，终结了RWA行业的灰色时代',
    abstract: '2026年2月6日，中国人民银行联合七部委发布《关于进一步防范和处置虚拟货币等相关风险的通知》。这不是一纸普通的监管文件，而是一道划破迷雾的政策分水岭。本文从新政出台的底层逻辑、核心条款的实质内涵、对行业格局的深远影响三个维度，深度剖析这一历史性政策的真正意义，并对企业合规转型的路径给出判断。',
    category: '政策深析',
    publishedAt: '2026-02-08T10:00:00',
    readTime: 18,
    tags: ['八部委新政', '合规框架', 'RWA监管', '政策解读'],
    viewCount: 12840,
    likeCount: 986,
    commentCount: 124,
    featured: true,
    collectionTag: 'policy-analysis',
  },
];
